import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { Component, ElementRef, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { Console, debug } from 'console';
import { Address } from '../../../../models/address';
import { ChargingPower } from '../../../../models/chargingPower';
import { Manufacturer } from '../../../../models/manufacturer';
import { Model } from '../../../../models/model';
import { ToastService } from '../../../../services/toast/toast.service';




@Component({
  selector: 'app-create-charging-station',
  templateUrl: './create-charging-station.component.html',
  styleUrls: ['./create-charging-station.component.css']
})
export class CreateChargingStationComponent extends AbstractCreateEntityComponent implements OnInit {

  public className = 'CreateChargingStationComponent';

  public inviteLink: string;
  public installDate = new Date().toISOString().slice(0, 16);

  @Input() customerId: number;
  @Input() public hideSubmit: boolean = false;

  public passwordLength: number = 12;
  public includeNumbers: boolean = true;
  public includeSymbols: boolean = false;
  public password: string = '';

  chargingPowers: ChargingPower[] = [];
  manufacturers: Manufacturer[] = [];
  models: Model[] = [];
  modelsOfManufacturer: Model[] = [];
  address: Address[] = [];
  constructor(
    public toastService: ToastService,

    private chargingStationsService: ChargingStationsService,

    injector: Injector
  ) {
    super(chargingStationsService, injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.generatePassword();
  }

  ngAfterViewInit() {

    this.chargingStationsService.getChargingPower().subscribe(result => {
      this.chargingPowers = result;
    }, error => { });

    this.initModelsAndManufacturers();

    this.createForm();
  }

  initModelsAndManufacturers() {
    //Get Chargin-Station-Models and sort by Name
    this.chargingStationsService.getModels().subscribe(resultModels => {
      this.models = resultModels.sort((a, b) => a.name.localeCompare(b.name));;
      this.modelsOfManufacturer = this.models;

      //Get Manufacturer and InnerJoin with Models
      this.chargingStationsService.getManufacturer().subscribe(resultManufacturer => {
        this.manufacturers = resultManufacturer.filter(manufacturer =>
          this.models.some(model => model.manufacturerId.toString() == manufacturer.id)
        );

        //Sort by Name, but CUBOS first
        this.manufacturers.sort((a, b) => {
          if (a.name === "CUBOS") return -1;
          if (b.name === "CUBOS") return 1;
          return a.name.localeCompare(b.name);
        });
      }, error => { });
    }, error => { });
  }

  pwlength(event) {
    this.passwordLength = event.target.value;
    console.log(this.passwordLength);
  }

  hasNum(event) {
    this.includeNumbers = event.target.checked;
    console.log(this.includeNumbers);
  }

  hasSym(event) {
    this.includeSymbols = event.target.checked;
    console.log(this.includeSymbols);
  }

  generatePassword() {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    let validChars = letters;
    if (this.includeNumbers) {
      validChars += numbers;
    }
    if (this.includeSymbols) {
      validChars += symbols;
    }

    let generatedPassword = '';
    for (let i = 0; i < this.passwordLength; i++) {
      const index = Math.floor(Math.random() * validChars.length);
      generatedPassword += validChars[index];
    }

    this.password = generatedPassword;
    this.formService.form.controls['key'].setValue(this.password); 

  }


  createForm() {
    this.formService.validators = {
      name: [Validators.required],
      location: [],
      address: [Validators.required],
      manufacturerId: [Validators.required],
      modelId: [Validators.required],
      installationDate: [Validators.required],
      connectorSystemsId: [],
      key:[],
    }

    

    this.formService.form = new UntypedFormGroup({
      name: new UntypedFormControl('', this.formService.validators['name']),
      location: new UntypedFormControl('', this.formService.validators['location']),
      postalCode: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(5)]),
      city: new UntypedFormControl('', this.formService.validators['address']),
      street: new UntypedFormControl('', this.formService.validators['address']),
      houseNumber: new UntypedFormControl('', this.formService.validators['address']),
      manufacturerId: new UntypedFormControl('', this.formService.validators['manufacturerId']),
      modelId: new UntypedFormControl('', this.formService.validators['modelId']),
      connectorSystemsId: new UntypedFormControl('', this.formService.validators['connectorSystemsId']),
      key: new UntypedFormControl(this.password, this.formService.validators['key']),
    });
  }

  getModels(manufacturerId) {
    this.modelsOfManufacturer = this.models.filter(x => x.manufacturerId == manufacturerId);
  }

  onSubmit(formValue) {
    //super.createEntity(new ChargingStation(formValue));
  }



  modelIdChange(selectedModelId) {
    var modelsById = this.models.filter(x => x.id == selectedModelId)
    if (!modelsById) return;

    this.formService.form.patchValue({ manufacturerId: modelsById[0].manufacturerId })
    this.getModels(modelsById[0].manufacturerId);
  }


  postalCodeInput(event: Event) {
    this.toastService.clear();
    const inputValue = (event.target as HTMLInputElement).value;
    const regexNonDigits: RegExp = /[^0-9]/g;

    if (regexNonDigits.test(inputValue)) {
      (event.target as HTMLInputElement).value = inputValue.replace(regexNonDigits, '');
      this.toastService.error(`Eingabefehler bei PLZ: Nur Zahlen und maximal 5 Zeichen erlaubt`, 0, true);
    }
  }
}
